import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { postApi } from "../components/Utility";

class DriverBacklogMonitorStore {
    loading = false;
    total = 0;
    driverBacklogData = []
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            driverBacklogData: observable,

            getDriverBacklogData: action

        });
        this.rootStore = rootStore;
    }

    async getDriverBacklogData(driverId) {
        this.loading = true
        var postData = {
            driverId: driverId,
        };

        var response = await postApi
            .getClient()
            .get("http://localhost:3069" + "/cashier/getDriverBacklogData", {
                params: postData,
            });

        this.driverBacklogData = response?.data?.driverBacklogData

        this.loading = false
        return response?.data?.driverBacklogData
    }


}
export default DriverBacklogMonitorStore;